import React, {useState, useEffect} from 'react';
import styled, {css} from 'styled-components';
import {motion} from 'framer-motion';

/*
    Not shown until the user drags a file over the drop area, then its opacity is set to 1.
    Its pointer-events property is set to none so that the user can still interact with the items behind it.
    Its position is set to absolute so that it doesn't affect the layout of the parent container.

    It adds a global event and is shown when a file is dragged anywhere on the page.
    When the file is dragged over the drop area, the event is triggered and the opacity of the drop area is set to 1.
*/

const DropArea = styled(motion.div)`
    position: relative;
    &:after {
        content: '';
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        // Green
        background-color: rgba(0, 255, 0, 0.1);
        border: 2px dashed rgba(0, 255, 0, 0.5);
        border-radius: 10px;
        position: absolute;
        opacity: var(--dragging, 0);
        z-index: 1;
        transition: opacity 0.3s;
        pointer-events: none;
    }
`;

const FileInputDragNDrop = ({children, onDrop, use: Component, ...props}) => {
    const [dragging, setDragging] = useState(false);
    const handleDragEnter = e => {
        e.preventDefault();
        e.stopPropagation();
        setDragging(true);
        window.currentDrag = e;
    };

    const handleDragLeave = e => {
        e.preventDefault();
        setDragging(false);
        if (window.currentDrag.target === e.target) {
            window.currentDrag = null;
        }
    };

    return (
        <DropArea
            as={Component}
            style={{
                '--dragging': dragging ? 1 : 0
            }}
            onDrop={e => {
                console.log('onDrop', e);
                e.preventDefault();
                e.stopPropagation();
                setDragging(false);
                onDrop({
                    target: {
                        files: e.dataTransfer.files
                    }
                });
            }}
            onDragEnter={handleDragEnter}
            onDragLeave={handleDragLeave}
            onDragOver={e => {
                e.preventDefault();
                setDragging(true);
            }}
            {...props}
        >
            {children}
        </DropArea>
    );
};

export default FileInputDragNDrop;
